import { create } from 'zustand';
import { isF1Device } from '../utils/isF1Device';

declare global {
  interface Window {
    onConnectionChange?: (isConnected: boolean) => void;
  }
}

interface F1NetworkState {
  online: boolean;
  isOffline: boolean;
  setOnline: (online: boolean) => void;
}

const isF1 = isF1Device();

export const useF1NetworkState = create<F1NetworkState>((set) => ({
  isOffline: false,
  online: isF1 ? window.Android?.getConnectionState?.() ?? true : true,
  setOnline: (online: boolean) => set({ online, isOffline: !online }),
}));

// Register Android bridge callback (runs once at module load)
if (isF1) {
  window.onConnectionChange = (isConnected: boolean) => {
    useF1NetworkState.getState().setOnline(isConnected);
  };

  // Re-check connection state when app comes to foreground
  // (handles case where network changed while app was backgrounded)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      const currentState = window.Android?.getConnectionState?.();
      if (currentState !== undefined) {
        useF1NetworkState.getState().setOnline(currentState);
      }
    }
  });
}
